/* SKY inline header search: predictive dropdown fed by /search/suggest.json.
   2-character minimum, 200ms debounce, keyboard navigation, closes on
   Escape / outside click. The mobile modal keeps the theme's own predictive
   search untouched. */
(() => {
  if (window.skySearchInit) return; window.skySearchInit = true;
  const esc = (s) => s.replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = (v) => 'LE ' + Number(v).toLocaleString('en-US', {minimumFractionDigits: 2});
  /* sizes the store carries: 36-48 whole plus the five half sizes */
  const SIZES = new Set(['36','37','37.5','38','39','39.5','40','41','41.5','42','43','43.5','44','45','45.5','46','47','48']);
  const sizeOf = (q) => {
    const n = q.replace(',', '.');
    if (!/^\d+(\.\d+)?$/.test(n)) return null;
    const s = String(parseFloat(n));
    return SIZES.has(s) ? s : null;
  };
  const init = () => {
    document.querySelectorAll('form.sky-hsearch').forEach((form) => {
      const input = form.querySelector('.sky-hsearch__input');
      const box = form.querySelector('.sky-hsearch__drop');
      if (!input || !box) return;
      let items = [], idx = -1, ctrl = null, timer = null;
      const close = () => { box.hidden = true; box.innerHTML = ''; items = []; idx = -1; input.setAttribute('aria-expanded', 'false'); };
      const select = (n) => {
        items.forEach((el) => el.classList.remove('is-sel'));
        idx = n;
        if (idx >= 0 && items[idx]) { items[idx].classList.add('is-sel'); items[idx].scrollIntoView({block: 'nearest'}); }
      };
      const render = (d, q) => {
        const prods = (d.products || []).slice(0, 6);
        const cols = (d.collections || []).slice(0, 4);
        const size = sizeOf(q);
        if (!prods.length && !cols.length && !size) { close(); return; }
        let html = '';
        if (size) {
          html += '<a class="sky-hsearch__item sky-hsearch__item--size" href="/collections/all?filter.v.option.shoe+size='
            + size + '"><span class="sky-hsearch__ititle">See all size ' + size + ' &rarr;</span></a>';
        }
        if (prods.length) {
          html += '<div class="sky-hsearch__glabel">Products</div>';
          html += prods.map((p) => {
            const img = p.image ? esc(p.image) + (p.image.includes('?') ? '&' : '?') + 'width=80' : '';
            return '<a class="sky-hsearch__item" href="' + esc(p.url) + '">'
              + (img ? '<img src="' + img + '" width="40" height="40" loading="lazy" alt="">' : '<span class="sky-hsearch__noimg"></span>')
              + '<span class="sky-hsearch__ititle">' + esc(p.title) + '</span>'
              + '<span class="sky-hsearch__iprice">' + money(p.price) + '</span></a>';
          }).join('');
        }
        if (cols.length) {
          html += '<div class="sky-hsearch__glabel">Collections &amp; brands</div>';
          html += cols.map((c) => '<a class="sky-hsearch__item" href="' + esc(c.url) + '"><span class="sky-hsearch__ititle">' + esc(c.title) + '</span></a>').join('');
        }
        box.innerHTML = html; box.hidden = false; input.setAttribute('aria-expanded', 'true');
        items = [...box.querySelectorAll('.sky-hsearch__item')]; idx = -1;
      };
      input.addEventListener('input', () => {
        const q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(async () => {
          if (ctrl) ctrl.abort();
          ctrl = new AbortController();
          try {
            const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(q)
              + '&resources[type]=product,collection&resources[limit]=6', {signal: ctrl.signal});
            const d = await r.json();
            render(d.resources.results, q);
          } catch (e) { /* aborted or offline: leave as-is */ }
        }, 200);
      });
      input.addEventListener('keydown', (e) => {
        if (box.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); select(Math.min(idx + 1, items.length - 1)); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); select(Math.max(idx - 1, -1)); }
        else if (e.key === 'Enter' && idx >= 0 && items[idx]) { e.preventDefault(); window.location.assign(items[idx].getAttribute('href')); }
        else if (e.key === 'Escape') { close(); }
      });
      document.addEventListener('pointerdown', (e) => { if (!form.contains(e.target)) close(); });
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
